import React, { useEffect, useRef, useState } from "react";
import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { toast } from "../../../../../node_modules/react-toastify";
import AreaService from "services/Admin/AreasService";
import Select from "react-select";
import { SuccessOk } from "configs/statusCode";
import CountriesService from "services/Admin/CountriesService";

const FilterModal = ({
	filterModal,
	setFilterModal,
	filtersData,
	updateFiltersData,
}) => {
	const areaService = new AreaService();
	const countriesService = new CountriesService();
	const [formData, setFormData] = useState({
		area_ids: "",
		country: "",
	});
	const [areaOptions, setAreaOptions] = useState([]);
	const [countryOptions, setCountryOptions] = useState([]);
	const formRef = useRef();

	useEffect(() => {
		setFormData({ ...filtersData });
	}, []);

	useEffect(() => {
		countriesService.getDropDown().then((res) => {
			const newOptions = res?.data?.map((item) => {
				return {
					label: item.name.en,
					value: item.id,
				};
			});
			setCountryOptions(newOptions);
		});
	}, []);

	useEffect(() => {
		if (!!formData.country?.value) {
			areaService.getAreaDropDown().then((res) => {
				if (res.status == SuccessOk) {
					const newOptions = res.data.map((item) => {
						return {
							label: item.name.en ? item.name.en : item.name,
							value: item.id,
						};
					});
					setAreaOptions(newOptions);
				}
			});
		}
	}, [formData.country]);

	return (
		<AvForm className="form-horizontal">
			<Modal
				isOpen={filterModal}
				toggle={() => setFilterModal(!filterModal)}
				className="rightModalSide scrollbar-container mt-0">
				<ModalHeader toggle={() => setFilterModal(!filterModal)}>
					Resale Filters
				</ModalHeader>
				<ModalBody>
					<Row>
						<Col md={12}>
							<label>Countries</label>
							<Select
								placeholder={"Select"}
								options={countryOptions}
								onChange={(data) => {
									setFormData({ ...formData, country: data, area_ids: null });
								}}
								value={formData.country}
							/>
						</Col>
						<Col md={12} className="mt-3">
							<label>Location</label>
							<Select
								placeholder="Select"
								options={areaOptions}
								noOptionsMessage={() => {
									if (!formData.country?.label) {
										return "Choose Country First";
									}
								}}
								onChange={(data) => {
									setFormData({ ...formData, area_ids: data });
								}}
								value={formData.area_ids}
								isMulti={true}
							/>
						</Col>
					</Row>
				</ModalBody>
				<ModalFooter className="mt-4 px-0 d-flex justify-content-between">
					<button
						type="button"
						className="btn btn-light w-120"
						onClick={() => {
							setFormData({ area_ids: "", country: "" });
							setAreaOptions([]);
							updateFiltersData({ area_ids: "", country: "" });
							setFilterModal(false);
						}}>
						Reset Filter
					</button>

					<button
						type="button"
						onClick={() => {
							updateFiltersData({
								area_ids: formData.area_ids,
								country: formData.country,
							});
							setFilterModal(!filterModal);
						}}
						className="btn btn-success  w-120">
						Apply Filter
					</button>
				</ModalFooter>
			</Modal>
		</AvForm>
	);
};
export default FilterModal;
